import React from "react";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";

// component
import {LangController} from "../../../components/tabs/langController";

// labels
import {FL_DESCRIPTION, FL_NAME} from "../../../components/i18n/formLabels";
import {PH_DESCRIPTION, PH_NAME} from "../../../components/i18n/placeHolders";

const DestinationLangs = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name, showOrder:lang?.showOrder },
            name: '',
            description: '',
        }) )

        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md={"12"}>
                <FormGroup>
                    <Label>{FL_NAME}</Label>
                    <Input
                        type="text"
                        name="name"
                        placeholder={PH_NAME}
                        value= { child.name }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md={"12"}>
                <FormGroup>
                    <Label>{FL_DESCRIPTION}</Label>
                    <Input
                        type="textarea"
                        rows="2"
                        name="description"
                        placeholder={PH_DESCRIPTION}
                        value= { child.description }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    return <LangController
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />
}

export default DestinationLangs